import { actionTypeKeys } from "../actions/actionTypeKeys";
import { AnyAction } from "redux";
import { initialState, emptyCustomer } from "../store/initialState";
import { CustomerState } from "../types/authentication";
import { CustomerPreferences } from "../types/customer";

export default function authenticationReducer(
  state: CustomerState = initialState.authentication,
  action: AnyAction
): CustomerState {
  switch (action.type) {
    case actionTypeKeys.AUTHENTICATION_SUCCESS:
      return {
        ...state,
        isCustomer: true,
        isSignedIn: true,
        customer: { ...action.customer },
        error: null
      };
    case actionTypeKeys.GUEST_SIGN_IN:
      return {
        ...state,
        isCustomer: false,
        isSignedIn: true,
        customer: { ...emptyCustomer },
        error: null
      };
    case actionTypeKeys.AUTHENTICATION_FAILED:
      return {
        ...state,
        isCustomer: false,
        isSignedIn: false,
        customer: { ...emptyCustomer },
        error: { ...action.error }
      };
    case actionTypeKeys.SCHEDULE_APPOINTMENT_SUCCESS:
      return state.customer.id < 0
        ? {
            ...state,
            customer: {
              ...state.customer,
              id: action.appointment.customerId
            }
          }
        : state;
    case actionTypeKeys.LOGOUT_SUCCESS:
      return {
        isServiceRep: false,
        serviceRepEmail: "",
        isCustomer: false,
        isSignedIn: false,
        customer: { ...emptyCustomer },
        error: null
      };
    case actionTypeKeys.SERVICE_REP_SIGN_IN_SUCCESS:
      return {
        ...state,
        isServiceRep: true,
        serviceRepEmail: action.email
      };
    case actionTypeKeys.CUSTOMER_PREFERENCES_UPDATED_SUCCESS:
      const preferences: CustomerPreferences = action.preferences;
      return {
        ...state,
        customer: {
          ...state.customer,
          phone: preferences.preferredPhone,
          email: preferences.preferredEmail
        }
      };
    default:
      return state;
  }
}
